import { createContext } from 'react';

export const MAP = '__GMAP_MAP';
export const GOOGLE = '__GMAP_GOOGLE';
export const MapContext = createContext({});
